import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "components/Button";
import OtpTimmer from "components/OtpTimer";
import tickSign from "assets/images/tickSign.gif";
import {Heading, SubHeading, TickSignWrapper,OTPWrapper} from "styles/components/SuccessMsg";
import {Footer} from "styles/pages/global";
const SuccessMsg = (props) => {
const navigate = useNavigate();
const isForgotPassword = props.actionType === "forgotPassword";
const isLoginButton = props?.response?.buttonName === "Login";
const isVerifyOtp= props?.response?.buttonName === "OK";
const headingKey = isForgotPassword ? props.locale("checkYourEmail"): isLoginButton ? props.locale("congratulations"):isVerifyOtp ? props.locale('successHeading') :props?.response?.heading;
const descriptionKey = isForgotPassword ? props.locale("passwordResetSent"): isLoginButton ? props.locale("passwordSetupSuccess"):isVerifyOtp ? props.locale('successHeading'): props?.response?.description;
const forgotLocal = isForgotPassword ? props?.response?.buttonName : isVerifyOtp  ? props?.response?.buttonName : props.locale('login');
return (    
    <>
    <TickSignWrapper><img src={tickSign} alt="tickSign"/></TickSignWrapper>
        <Heading className="text-center">{headingKey}</Heading>
        <SubHeading className="text-center">
          {descriptionKey}
        </SubHeading>

        <Footer>
          {/* <div style={{"width": "150px", margin: "0 auto"}}> */}
          <div style={{"width": "", margin: "0 auto"}}>
            <Button
              handleClick={() => {
                navigate(props?.response?.navigationLink)
              } }
            >
            {forgotLocal}
           
            </Button>
          </div>            
        </Footer>
        
        {props?.actionType === "forgotPassword" && <OTPWrapper>
          <OtpTimmer btnTxt={props.locale('resendLink')} callBack={()=>{
            props?.callBack()
          }}/>
        </OTPWrapper>}

        
    </>
  );
};

export default SuccessMsg;
